module.exports = __webpack_public_path__ + "static/2aff939d-e5bc-41bd-a07d-5529bcf4dbac-42c705d2daa7cff565ffcb422f4e9f5e.webp";